var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"prediction-result"},[(_vm.result)?_vm._l((_vm.badges),function(badge){return _c('span',{key:badge.kind,staticClass:"result-badge",class:'result-' + badge.kind},[_vm._v(_vm._s(badge.label))])}):_c('span',[_vm._v(_vm._s(_vm.fallback))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }